import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { DeliverableCard, Deliverable, DeliverableStatus } from '../components/DeliverableCard';
import { ArrowLeft, CheckCircle2, Clock, AlertCircle, ListTodo } from 'lucide-react';
const mockDeliverables: Deliverable[] = [{
  id: '1',
  projectId: '1',
  creatorId: '1',
  creatorName: 'You',
  contentType: 'post',
  platform: 'instagram',
  status: 'approved',
  deadline: '2024-06-10',
  description: 'Product showcase post with lifestyle photography'
}, {
  id: '2',
  projectId: '1',
  creatorId: '1',
  creatorName: 'You',
  contentType: 'story',
  platform: 'instagram',
  status: 'in_progress',
  deadline: '2024-06-12',
  description: 'Behind-the-scenes story series (3 slides)'
}, {
  id: '3',
  projectId: '1',
  creatorId: '1',
  creatorName: 'You',
  contentType: 'reel',
  platform: 'instagram',
  status: 'planned',
  deadline: '2024-06-14',
  description: 'Dynamic reel showcasing product features'
}, {
  id: '4',
  projectId: '1',
  creatorId: '1',
  creatorName: 'You',
  contentType: 'video',
  platform: 'youtube',
  status: 'submitted',
  deadline: '2024-06-13',
  description: 'Full product review and unboxing video'
}, {
  id: '5',
  projectId: '2',
  creatorId: '1',
  creatorName: 'You',
  contentType: 'post',
  platform: 'instagram',
  status: 'planned',
  deadline: '2024-06-20',
  description: 'Fitness routine with Adidas gear'
}, {
  id: '6',
  projectId: '2',
  creatorId: '1',
  creatorName: 'You',
  contentType: 'reel',
  platform: 'tiktok',
  status: 'planned',
  deadline: '2024-06-22',
  description: 'Quick workout tips video'
}];
export function CreatorDeliverablesPage() {
  const navigate = useNavigate();
  const [deliverables, setDeliverables] = useState(mockDeliverables);
  const [filter, setFilter] = useState<'all' | DeliverableStatus>('all');
  const filteredDeliverables = filter === 'all' ? deliverables : deliverables.filter(d => d.status === filter);
  const stats = {
    total: deliverables.length,
    completed: deliverables.filter(d => d.status === 'published').length,
    inProgress: deliverables.filter(d => d.status === 'in_progress' || d.status === 'submitted' || d.status === 'approved').length,
    pending: deliverables.filter(d => d.status === 'planned').length
  };
  const handleStatusChange = (deliverableId: string, newStatus: DeliverableStatus) => {
    setDeliverables(prev => prev.map(d => d.id === deliverableId ? {
      ...d,
      status: newStatus
    } : d));
  };
  return <div className="min-h-screen bg-gray-50 pb-12" data-id="element-731">
      <header className="bg-white border-b sticky top-0 z-10" data-id="element-732">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-733">
          <div className="flex items-center" data-id="element-734">
            <Button variant="ghost" size="sm" className="mr-4" onClick={() => navigate('/creator')} data-id="element-735">
              <ArrowLeft className="h-4 w-4 mr-2" data-id="element-736" /> Back
            </Button>
            <h1 className="text-xl font-bold text-gray-900" data-id="element-737">My Deliverables</h1>
          </div>
        </div>

        {/* Tabs */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-738">
          <div className="flex space-x-8 -mb-px" data-id="element-739">
            <button onClick={() => navigate('/creator')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-740">
              Dashboard
            </button>
            <button onClick={() => navigate('/creator/campaigns')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-741">
              Campaigns
            </button>
            <button className="pb-4 text-sm font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-742">
              Deliverables
            </button>
            <button onClick={() => navigate('/creator/brands')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-743">
              Brands
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-744">
        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-745">
          <Card data-id="element-746">
            <CardContent className="p-6" data-id="element-747">
              <div className="flex items-center justify-between" data-id="element-748">
                <div data-id="element-749">
                  <p className="text-sm text-gray-500" data-id="element-750">Total</p>
                  <p className="text-2xl font-bold text-gray-900" data-id="element-751">
                    {stats.total}
                  </p>
                </div>
                <div className="h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-752">
                  <ListTodo className="h-6 w-6 text-blue-600" data-id="element-753" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card data-id="element-754">
            <CardContent className="p-6" data-id="element-755">
              <div className="flex items-center justify-between" data-id="element-756">
                <div data-id="element-757">
                  <p className="text-sm text-gray-500" data-id="element-758">Completed</p>
                  <p className="text-2xl font-bold text-green-600" data-id="element-759">
                    {stats.completed}
                  </p>
                </div>
                <div className="h-12 w-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-760">
                  <CheckCircle2 className="h-6 w-6 text-green-600" data-id="element-761" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card data-id="element-762">
            <CardContent className="p-6" data-id="element-763">
              <div className="flex items-center justify-between" data-id="element-764">
                <div data-id="element-765">
                  <p className="text-sm text-gray-500" data-id="element-766">In Progress</p>
                  <p className="text-2xl font-bold text-blue-600" data-id="element-767">
                    {stats.inProgress}
                  </p>
                </div>
                <div className="h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-768">
                  <Clock className="h-6 w-6 text-blue-600" data-id="element-769" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card data-id="element-770">
            <CardContent className="p-6" data-id="element-771">
              <div className="flex items-center justify-between" data-id="element-772">
                <div data-id="element-773">
                  <p className="text-sm text-gray-500" data-id="element-774">Pending</p>
                  <p className="text-2xl font-bold text-gray-600" data-id="element-775">
                    {stats.pending}
                  </p>
                </div>
                <div className="h-12 w-12 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-776">
                  <AlertCircle className="h-6 w-6 text-gray-600" data-id="element-777" />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Filters */}
        <div className="flex items-center space-x-2 mb-6" data-id="element-778">
          <Button variant={filter === 'all' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('all')} data-id="element-779">
            All ({stats.total})
          </Button>
          <Button variant={filter === 'planned' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('planned')} data-id="element-780">
            Planned
          </Button>
          <Button variant={filter === 'in_progress' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('in_progress')} data-id="element-781">
            In Progress
          </Button>
          <Button variant={filter === 'submitted' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('submitted')} data-id="element-782">
            Submitted
          </Button>
          <Button variant={filter === 'approved' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('approved')} data-id="element-783">
            Approved
          </Button>
          <Button variant={filter === 'published' ? 'secondary' : 'ghost'} size="sm" onClick={() => setFilter('published')} data-id="element-784">
            Published
          </Button>
        </div>

        {/* Deliverables Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-785">
          {filteredDeliverables.map(deliverable => <DeliverableCard key={deliverable.id} deliverable={deliverable} onStatusChange={handleStatusChange} data-id="element-786" />)}
        </div>
      </main>
    </div>;
}